module.exports = __webpack_public_path__ + "static/media/primary-manual.1a799eef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/primary-manual.jpg
// module id = 145
// module chunks = 0